export const SETUP_GAME = 'SETUP_GAME';
export const MAKE_GUESS = 'MAKE_GUESS';
export const START_NEW_GAME = 'START_NEW_GAME';



// WEBPACK FOOTER //
// ./src/actions/types.js